import { SearchPage } from './search/SearchPage';

export default function TherapistsPage() {
  return <SearchPage />;
}
